'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Form = require('react-bootstrap/lib/Form');

var _Form2 = _interopRequireDefault(_Form);

var _FormControl = require('react-bootstrap/lib/FormControl');

var _FormControl2 = _interopRequireDefault(_FormControl);

var _SearchSecondary = require('@scoir/brand-icons/dist/SearchSecondary');

var _SearchSecondary2 = _interopRequireDefault(_SearchSecondary);

var _CancelSecondary = require('@scoir/brand-icons/dist/CancelSecondary');

var _CancelSecondary2 = _interopRequireDefault(_CancelSecondary);

require('./TableOptions.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableOptions = function (_React$Component) {
    _inherits(TableOptions, _React$Component);

    function TableOptions(props) {
        _classCallCheck(this, TableOptions);

        var _this = _possibleConstructorReturn(this, (TableOptions.__proto__ || Object.getPrototypeOf(TableOptions)).call(this, props));

        _this.state = {
            filter: _this.props.filter || ''
        };
        return _this;
    }

    _createClass(TableOptions, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.filter !== this.props.filter) {
                this.setState({ filter: this.props.filter });
            }
        }
    }, {
        key: 'clearSearchInput',
        value: function clearSearchInput() {
            var filter = '';
            this.setState({ filter: filter });
            this.props.onFilterChange(filter);
        }
    }, {
        key: 'submit',
        value: function submit(e) {
            e.preventDefault();
            this.props.onFilterChange(this.state.filter);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _Form2.default,
                { inline: true, className: 'table-options-comp', onSubmit: function onSubmit(e) {
                        return _this2.submit(e);
                    } },
                _react2.default.createElement(_FormControl2.default, {
                    type: 'text',
                    placeholder: 'Search...',
                    value: this.state.filter,
                    onChange: function onChange(e) {
                        return _this2.setState({ filter: e.target.value });
                    } }),
                this.state.filter ? _react2.default.createElement(
                    'span',
                    { className: 'search-icon clear-input-icon', onClick: function onClick() {
                            return _this2.clearSearchInput();
                        } },
                    _react2.default.createElement(_CancelSecondary2.default, null)
                ) : _react2.default.createElement(_SearchSecondary2.default, { className: 'search-icon' })
            );
        }
    }]);

    return TableOptions;
}(_react2.default.Component);

TableOptions.propTypes = {
    filter: _propTypes2.default.string,
    onFilterChange: _propTypes2.default.func
};

exports.default = TableOptions;
//# sourceMappingURL=TableOptions.js.map